/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { analyticsWhatsAppCampaignAnalytics } from '../../axios/analyticsWhatsAppCampaignAnalytics'
import type {
	AnalyticsWhatsAppCampaignAnalyticsError,
	AnalyticsWhatsAppCampaignAnalyticsPathParams,
	AnalyticsWhatsAppCampaignAnalyticsQueryParams,
	AnalyticsWhatsAppCampaignAnalyticsResponse,
} from '../../types/AnalyticsWhatsAppCampaignAnalytics'

export const analyticsWhatsAppCampaignAnalyticsQueryKey = (
	campaign: AnalyticsWhatsAppCampaignAnalyticsPathParams['campaign'],
	params?: AnalyticsWhatsAppCampaignAnalyticsQueryParams,
) => [{ url: '/campaigns/:campaign/whatsapp-analytics', params: { campaign } }, ...(params ? [params] : [])] as const

export type AnalyticsWhatsAppCampaignAnalyticsQueryKey = ReturnType<typeof analyticsWhatsAppCampaignAnalyticsQueryKey>

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppCampaignAnalytics */
export function analyticsWhatsAppCampaignAnalyticsQueryOptions(
	campaign: AnalyticsWhatsAppCampaignAnalyticsPathParams['campaign'],
	params?: AnalyticsWhatsAppCampaignAnalyticsQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AnalyticsWhatsAppCampaignAnalyticsResponse,
		AxiosError<AnalyticsWhatsAppCampaignAnalyticsError>,
		AnalyticsWhatsAppCampaignAnalyticsResponse,
		AnalyticsWhatsAppCampaignAnalyticsQueryKey
	>({
		queryKey: analyticsWhatsAppCampaignAnalyticsQueryKey(campaign, params),
		queryFn: ({ signal }) =>
			analyticsWhatsAppCampaignAnalytics(campaign, params, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppCampaignAnalytics */
export function useAnalyticsWhatsAppCampaignAnalytics<TSelectData = AnalyticsWhatsAppCampaignAnalyticsResponse>(
	campaign: AnalyticsWhatsAppCampaignAnalyticsPathParams['campaign'],
	params?: AnalyticsWhatsAppCampaignAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AnalyticsWhatsAppCampaignAnalyticsResponse,
					AxiosError<AnalyticsWhatsAppCampaignAnalyticsError>,
					TSelectData,
					AnalyticsWhatsAppCampaignAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AnalyticsWhatsAppCampaignAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...analyticsWhatsAppCampaignAnalyticsQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppCampaignAnalytics */
export function useAnalyticsWhatsAppCampaignAnalyticsSuspense<TSelectData = AnalyticsWhatsAppCampaignAnalyticsResponse>(
	campaign: AnalyticsWhatsAppCampaignAnalyticsPathParams['campaign'],
	params?: AnalyticsWhatsAppCampaignAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AnalyticsWhatsAppCampaignAnalyticsResponse,
					AxiosError<AnalyticsWhatsAppCampaignAnalyticsError>,
					TSelectData,
					AnalyticsWhatsAppCampaignAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AnalyticsWhatsAppCampaignAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...analyticsWhatsAppCampaignAnalyticsQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
